import { Link, useNavigate } from "react-router-dom";
import SideBareMagasin from "../SideBareMagasin/SideBareMagasin";
import "./notification.css";
import "./responsiveNotification.css";
import { useContext, useEffect, useState } from "react";
import { MagasinContext } from "../../../Context/MagasinContext";
import GetNotification from "../../../Services/Magasin/GetNotification";
import { NotificationMagasinType } from "../../../Modeles/NotificationModel";
import axios from "axios";
import { NewSideBarMagasins } from "../../NewSidebarMagasin";

export interface Notification {
  Notification: NotificationMagasinType[];
  messageErros: string;
}

export default function NotificationMagasin() {
  const magasinContext = useContext(MagasinContext);
  const MagasinId = localStorage.getItem("MagasinId");
  const panier = localStorage.getItem("paniermagasin");
  const id = MagasinId || magasinContext.id?.id;
  const [loading, setLoading] = useState(true);

  const [state, setState] = useState<Notification>({
    Notification: [] as NotificationMagasinType[],
    messageErros: "accune Notification",
  });

  useEffect(() => {
    setState({ ...state });
    setLoading(true);

    GetNotification()
      .getNotif()
      .then((res) => {
        setState({ ...state, Notification: res.data });
        setLoading(false);
      })
      .catch((msg) => {
        setState({ ...state, Notification: msg.messageErros });
        setLoading(false);
      });
  }, []);

  const navigate = useNavigate();
  const [Popup, setPopup] = useState(false);
  
  const close = (e: any) => {
    e.preventDefault();
    setPopup(false);
  };

  const MarkAsRead = async (IdNotif: any) => {
    try {
      await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/magasins/${id}/notification/${IdNotif}`);
      setPopup(true);
    } catch (error) {
      console.error("Erreur lors de la mise à jour de la notification", error);
    }
  };
  
  const [selectedNotif, setSelectedNotif] = useState<any>(null);

  const handleClickNotif = (notif: any) => {
    setSelectedNotif(notif);
    setPopup(true);
    // Optimistically mark as read in local state immediately
    if (notif.IsRead !== 1) {
      setState(prev => ({
        ...prev,
        Notification: prev.Notification.map((n: any) =>
          n.id === notif.id ? { ...n, IsRead: 1 } : n
        ),
      }));
    }
    MarkAsRead(notif.id);
  };

  useEffect(() => {
    // Previously this page was forcing a body-scale layout hack.
    // The app now has a global responsive system + sidebar offset,
    // so no per-page body manipulation is needed.
  }, []);

  const { Notification, messageErros } = state;
  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);

  const formatDate = (raw: any) => {
    if (!raw) return "";
    const d = new Date(raw);
    if (isNaN(d.getTime())) return raw;
    return d.toLocaleString("fr-FR", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };
  
  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Count unread notifications
  const unreadCount = Notification.filter((n: any) => n.IsRead === 0).length;

  const getResolvedUrl = (rawUrl?: string) => {
    if (!rawUrl) return null;
    let url = rawUrl.trim();
    if (url.startsWith("/historiques")) {
      return `/magasins/${id}${url}`;
    }
    return url;
  };

  const isRemboursement = (notif: any) => {
    if (!notif) return false;
    const type = (notif.Type || "").toLowerCase();
    const title = (notif.Title || "").toLowerCase();
    return type.includes("remboursement") || title.includes("remboursement");
  };

  return (
    <>
      <NewSideBarMagasins />

      <div className="notifications-page-nmag">
        {/* Header Section */}
        <div className="notifications-header-nmag">
          <div className="header-content-nmag">
            <div className="header-left-nmag">
              <div className="header-icon-nmag">
                <i className="bi bi-bell-fill"></i>
              </div>
              <div className="header-text-nmag">
                <h1 className="header-title-nmag">Notifications</h1>
                <p className="header-subtitle-nmag">
                  Restez informé de toutes les activités
                </p>
              </div>
            </div>
            {unreadCount > 0 && (
              <div className="unread-badge-nmag">
                <span>{unreadCount} non lue{unreadCount > 1 ? "s" : ""}</span>
              </div>
            )}
          </div>
        </div>

        {/* Notifications Container */}
        <div className="notifications-container-nmag">
          {loading ? (
            <div className="loader-container-nmag">
              <div className="spinner-nmag"></div>
              <span className="loader-text-nmag">Chargement des notifications...</span>
            </div>
          ) : Notification && Notification.length > 0 ? (
            <div className="notifications-list-nmag">
              {Notification.map((notif: any, index: number) => (
                <div
                  key={notif.id}
                  className={`notification-card-nmag ${notif.IsRead === 1 ? "read-nmag" : "unread-nmag"}`}
                  onClick={() => handleClickNotif(notif)}
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  {/* Unread Indicator */}
                  {notif.IsRead === 0 && (
                    <div className="unread-indicator-nmag"></div>
                  )}

                  {/* Icon */}
                  <div className={`notification-icon-nmag ${notif.IsRead === 1 ? "read-icon-nmag" : "unread-icon-nmag"}`}>
                    <i className={isRemboursement(notif) ? "bi bi-arrow-counterclockwise" : "bi bi-bell-fill"}></i>
                  </div>

                  {/* Content */}
                  <div className="notification-content-nmag">
                    <div className="notification-header-row-nmag">
                      <h3 className="notification-title-nmag">
                        {notif.Title}
                      </h3>
                      <span className="notification-date-nmag">
                        {formatDate(notif.Date)}
                      </span>
                    </div>

                    <p className="notification-message-nmag">
                      {notif.Content}
                    </p>

                    {/* Status Badge */}
                    <div className="notification-footer-nmag">
                      <span className={`status-badge-nmag ${notif.IsRead === 1 ? "read-status-nmag" : "unread-status-nmag"}`}>
                        {notif.IsRead === 1 ? (
                          <>
                            <i className="bi bi-check-circle-fill"></i>
                            <span>Déjà lue</span>
                          </>
                        ) : (
                          <>
                            <i className="bi bi-circle-fill"></i>
                            <span>Nouvelle</span>
                          </>
                        )}
                      </span>

                      <div className="arrow-icon-nmag">
                        <i className="bi bi-arrow-right"></i>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="empty-state-nmag">
              <div className="empty-icon-wrapper-nmag">
                <i className="bi bi-bell-slash"></i>
              </div>
              <h2 className="empty-title-nmag">Aucune notification</h2>
              <p className="empty-text-nmag">
                Nous vous préviendrons dès qu'il y aura du nouveau.
                <br />
                Revenez plus tard pour vérifier vos notifications.
              </p>
            </div>
          )}
        </div>

        {/* Modal Popup */}
        {Popup && selectedNotif && (
          <div className="modal-overlay-nmag" onClick={() => setPopup(false)}>
            <div className="modal-card-nmag" onClick={(e) => e.stopPropagation()}>
              {/* Close Button */}
              <button className="modal-close-btn-nmag" onClick={() => setPopup(false)}>
                <i className="bi bi-x-lg"></i>
              </button>

              {/* Icon */}
              <div className="modal-icon-wrapper-nmag">
                <div className="modal-icon-nmag">
                  <i className={isRemboursement(selectedNotif) ? "bi bi-arrow-counterclockwise" : "bi bi-check-lg"}></i>
                </div>
              </div>

              {/* Content */}
              <div className="modal-content-nmag">
                <h2 className="modal-title-nmag">{selectedNotif.Title}</h2>
                <p className="modal-message-nmag">{selectedNotif.Content}</p>
                
                  <div className="modal-meta-nmag">
                    <span className="modal-date-nmag">
                      <i className="bi bi-clock"></i>
                      {formatDate(selectedNotif.Date)}
                    </span>
                  </div>
              </div>

              {/* Actions */}
              <div className="modal-actions-nmag">
                {getResolvedUrl(selectedNotif.Url) ? (
                  <Link
                    to={getResolvedUrl(selectedNotif.Url)!}
                    className="modal-btn-nmag primary-nmag"
                    onClick={() => setPopup(false)}
                  >
                    <span>Voir les détails</span>
                    <i className="bi bi-arrow-right"></i>
                  </Link>
                ) : (
                  <button
                    className="modal-btn-nmag primary-nmag"
                    onClick={() => setPopup(false)}
                  >
                    <span>D'accord</span>
                    <i className="bi bi-check-lg"></i>
                  </button>
                )}
                <button
                  className="modal-btn-nmag secondary-nmag"
                  onClick={() => setPopup(false)}
                >
                  Fermer
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}